/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qk_FieldInputs */

const en_qk_field = /** @type {(inputs: Qk_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Field`)
};

const de_qk_field = /** @type {(inputs: Qk_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feld`)
};

/**
* | output |
* | --- |
* | "Field" |
*
* @param {Qk_FieldInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const qk_field = /** @type {((inputs?: Qk_FieldInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qk_FieldInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_qk_field(inputs)
	return en_qk_field(inputs)
});